<template>
  <div class="ebook-empty-state">
    <div class="ebook-empty-state__card">
      <div class="ebook-empty-state__icon">
        <img :src="defaultCoverImg" alt="" class="ebook-empty-state__img" />
      </div>
      <p class="ebook-empty-state__text">
        Conteúdo em breve. Volte mais tarde.
      </p>
    </div>
  </div>
</template>

<script>
import defaultCoverImg from "@/assets/images/logo-dark.svg";

export default {
  name: "EbookEmptyState",
  data() {
    return {
      defaultCoverImg
    };
  }
};
</script>

<style lang="scss" scoped>
.ebook-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 16px;

  &__card {
    background-color: #1e2130;
    border-radius: 8px;
    padding: 48px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 360px;
    width: 100%;
    cursor: default;
  }

  &__icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    opacity: 0.4;
  }

  &__img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  &__text {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
    margin: 0;
    opacity: 0.6;
  }
}
</style>
